import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Link, Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useClubTheme } from '../contexts/ClubThemeContext';

const DISCLAIMER_KEY = 'disclaimerAccepted_v1';

function DisclaimerDialog() {
  const { t } = useTranslation();
  const { clubName } = useClubTheme();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(DISCLAIMER_KEY)) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(DISCLAIMER_KEY, 'true');
    setOpen(false);
  };

  const legalUrls = (() => {
    try {
      const config = JSON.parse(localStorage.getItem('clubConfig') || '{}');
      return config.legalUrls || {};
    } catch {
      return {};
    }
  })();

  const hasLinks = legalUrls.termsOfUse || legalUrls.codeOfConduct || legalUrls.privacyPolicy || legalUrls.dataBreachPolicy;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {t('legal.disclaimerTitle')}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          {t('legal.disclaimerText')}
        </Typography>

        {hasLinks && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {legalUrls.termsOfUse && (
              <Link href={legalUrls.termsOfUse} target="_blank" rel="noopener">
                {t('legal.termsOfUse')}
              </Link>
            )}
            {legalUrls.codeOfConduct && (
              <Link href={legalUrls.codeOfConduct} target="_blank" rel="noopener">
                {t('legal.codeOfConduct')}
              </Link>
            )}
            {legalUrls.privacyPolicy && (
              <Link href={legalUrls.privacyPolicy} target="_blank" rel="noopener">
                {t('legal.privacyPolicy')}
              </Link>
            )}
            {legalUrls.dataBreachPolicy && (
              <Link href={legalUrls.dataBreachPolicy} target="_blank" rel="noopener">
                {t('legal.dataBreachPolicy')}
              </Link>
            )}
          </Box>
        )}

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
          CONFIDENTIAL – {t('legal.propertyOf', { club: clubName })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleAccept}>
          {t('legal.accept')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DisclaimerDialog;
